import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './lib/analytics'; // init error tracking before anything can throw
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(<App />);
